// This are the editors per model to be used on each row in the table
// NOTE: name matter this should be the name of the model + 'Editor'
import AnswerEditor from './AnswerEditor'

export {
  AnswerEditor
}